module.exports = __webpack_public_path__ + "static/media/workingoffice.b794a2df.jpg";